<!-- @/components/LoadView.vue -->
<template>
  <div id="home">
    <transition name="fade">
      <div id="Login">
        <div class="login-container">
          <div class="left-text-container">
            <h2 class="title-main">武汉欧曼谛学生成长手册</h2>
            <h1 class="title-sub">welcome</h1>  
            <p class="desc-text">这里是武汉欧曼谛专属学生成长平台</p>
            <p class="desc-text">同学们可以随时上传自己的原创作品</p>
            <p class="desc-text">记录成长路上的每一步收获</p>
            <p class="slogan">高端时尚美业教育标准制定者</p>
          </div>
        </div>

        <div class="login-con">
          <div class="logo"></div>

          <el-form ref="form" :model="form" :rules="rules" class="demo-ruleForm">
            <div class="input-container">
              <el-form-item prop="username">
                <el-input v-model.trim="form.username" placeholder="账号" class="input-item" :disabled="loading"
                @input="clearError">
                  <i slot="prefix" class="el-icon-user"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="password">
                <el-input v-model.trim="form.password" placeholder="密码" type="password" class="input-item"
                  :disabled="loading" @keyup.enter.native="handleLogin"
                  @input="clearError">
                  <i slot="prefix" class="el-icon-lock"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="code" class="code-form-item">
                <div class="code-container">
                  <el-input v-model.trim="form.code" placeholder="验证码" class="input-item code-input" :disabled="loading"
                    @keyup.enter.native="handleLogin"
                    @input="clearError">
                    <i slot="prefix" class="el-icon-warning-outline"></i>
                  </el-input>
                  <div class="login-code">
                    <img :src="codeUrl" @click="getCode" class="login-code-img" />
                  </div>
                </div>
              </el-form-item>
            </div>

            <!-- 🔥 修复1：删除重复的按钮代码，只保留一个按钮 -->
            <div class="button-wrap">
              <div 
                class="custom-login-btn" 
                :class="{ 'is-disabled': loading }"
                @click="handleLogin"
              >
                <span v-if="loading">登录中...</span>
                <span v-else>登录</span>
              </div>
            </div>

            <!-- 统一错误提示区域 -->
            <el-form-item v-if="errorMessage" class="error-message">
              <el-alert :title="errorMessage" type="error" show-icon :closable="false" />
            </el-form-item>
           
          </el-form>
        </div>

        <!-- 注册对话框 -->
        <el-dialog title="注册账号" :visible.sync="dialogFormVisible" width="600px" :close-on-click-modal="false">
          <el-form ref="registerForm" :model="registerForm" :rules="rules" label-width="100px">
            <el-form-item label="登录账号" prop="username">
              <el-input v-model="registerForm.username" placeholder="登录账号,建议输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="registerForm.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入密码"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="NAME">
              <el-input v-model="registerForm.NAME" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-select v-model="registerForm.sex" placeholder="请选择性别">
                <el-option v-for="item in field101Options" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker v-model="registerForm.birthDate" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="身份证号" prop="card">
              <el-input v-model="registerForm.card" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="专业" prop="majorId">
              <el-select v-model="registerForm.majorName" placeholder="请选择专业">
                <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
                  :value="major.majorId" />
              </el-select>
            </el-form-item>
            <el-form-item label="班级" prop="classId">
              <el-select v-model="registerForm.classId" placeholder="请选择班级">
                <el-option v-for="item in classList" :key="item.id" :label="item.className"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="tel">
              <el-input v-model="registerForm.tel" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="家庭住址" prop="address">
              <el-input v-model="registerForm.address" placeholder="请输入家庭住址"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="registerForm.code" placeholder="请输入验证码">
                <template slot="append">
                  <img :src="codeUrl" @click="getCode" class="login-code-img" style="cursor: pointer; height: 38px;" />
                </template>
              </el-input>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false" :disabled="registerLoading">
              取消
            </el-button>
            <el-button class="custom-register-btn" @click="handleRegister" :loading="registerLoading">
              {{ registerLoading ? '注册中...' : '确定' }}
            </el-button>
          </div>
        </el-dialog>
      </div>
    </transition>
  </div>
</template>

<script>
import Loadview from '@/js/Loadview';

export default {
  ...Loadview,
  mounted() {
    // 组件挂载后的逻辑
  }
}
</script>

<style scoped>
/* 全局容器样式 */
#home {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  padding-right: 10px;
  background-image: url('@/assets/beijing.png');
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

/* 左侧文字容器 */
.login-container {
  height: 100%;
  width: 50%;
  border-radius: 10px 0 0 10px;
  background-image: url('@/assets/denglu.png');
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
  float: left;
}

/* 左侧文字样式 */
.left-text-container {
  width: 100%;
  text-align: center;
  color: white;
  padding-top: 80px;
}

.title-main {
  font-size: 26px;
  margin: 0 0 30px 0;
  letter-spacing: 0.5px;
  font-weight: bold;
}

.title-sub {
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 30px 0;
  font-weight: bold;
}

.desc-text {
  font-size: 15px;
  margin: 0 0 12px 0;
  line-height: 1.6;
  font-weight: bold;
}

.slogan {
  font-size: 18px;
  margin-top: 130px;
  letter-spacing: 0.2em;
  font-weight: bold;
}

/* 右侧登录容器 */
.login-con {
  height: 100%;
  width: 50%;
  float: right;
  border-radius: 0 10px 10px 0;
  padding: 0 20px;
  box-sizing: border-box;
}

/* logo样式 */
.logo {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;
  width: 186px;
  height: 56px;
  background: url('@/assets/logo.png') no-repeat left center / cover;
}

/* 登录框整体样式 */
#Login {
  height: 500px;
  width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  animation: slide-up 0.5s ease-out;
  display: -ms-flexbox;
  -ms-flex-align: center;
  -ms-flex-pack: center;
}

/* 表单项样式 */
.el-form-item {
  margin-bottom: 20px;
}

/* 验证码图片 */
.login-code-img {
  height: 38px;
  cursor: pointer;
}

/* 输入框容器 */
.input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  display: -ms-flexbox;
  -ms-flex-direction: column;
  -ms-flex-align: center;
}

/* 输入框样式 */
.input-item {
  width: 250px;
  border-radius: 10px;
  box-shadow: 1px 5px 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
}

/* 验证码表单项 */
.code-form-item {
  width: 250px;
}

/* 验证码容器 */
.code-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  display: -ms-flexbox;
  -ms-flex-align: center;
  -ms-flex-pack: justify;
}

/* 验证码输入框 */
.code-input {
  width: 180px;
  margin-right: 20px;
}

/* 验证码图片容器 */
.login-code {
  width: 100px;
  height: 58px;
}

/* 🔥 修复2：按钮容器 */
.button-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 10px 0 15px 0;
}

/* 🔥 修复3：核心 - 自定义登录按钮（放弃el-button，用原生button避免样式冲突） */
/* 微信小程序原生button样式重置 */
button {
  all: unset !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}

.custom-login-btn {
  /* 基础样式 */
  background-color: #ea5e71 !important;
  border-radius: 30px !important;
  color: #ffffff !important;
  border: none !important;
  width: 250px !important;
  height: 44px !important;
  font-size: 16px !important;
  font-weight: bold !important;
  cursor: pointer;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: background-color 0.3s ease;
  
  /* 文字样式 */
  text-shadow: none !important;
  -webkit-text-fill-color: #ffffff !important;
  
  /* 去除默认样式 */
  -webkit-appearance: none !important;
  appearance: none !important;
  outline: none !important;
  box-shadow: none !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
  text-indent: 0 !important;
  text-align: center !important;
  white-space: normal !important;
  line-height: 1 !important;
  
  /* 微信小程序特定样式 */
  background-image: none !important;
  border-image: none !important;
  -webkit-border-image: none !important;
}

.custom-login-btn span {
  color: #ffffff !important;
  text-shadow: none !important;
  -webkit-text-fill-color: #ffffff !important;
  font-size: 16px !important;
  font-weight: bold !important;
}

.custom-login-btn:hover {
  background-color: #d6336c !important;
}

.custom-login-btn:disabled {
  background-color: #ea5e71 !important;
  opacity: 0.8 !important;
  cursor: not-allowed !important;
}

.custom-login-btn:disabled span {
  color: #ffffff !important;
  text-shadow: none !important;
  -webkit-text-fill-color: #ffffff !important;
}

/* 注册按钮样式 */
.custom-register-btn {
  background-color: #ea5e71 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
}

.custom-register-btn:hover {
  background-color: #d6336c !important;
}

/* 错误提示 */
.error-message {
  margin-top: 10px;
  margin-bottom: 15px;
  width: 250px;
  margin-left: auto;
  margin-right: auto;
  background-color: transparent !important;
}

/* 动画效果 */
@keyframes slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  #Login {
    width: 90%;
    flex-direction: column;
    height: auto;
    padding: 20px 0;
  }
  .login-container, .login-con {
    width: 100%;
    float: none;
    border-radius: 10px 10px 0 0;
  }
  .login-con {
    border-radius: 0 0 10px 10px;
  }
}

/* 禁用状态样式 */
.input-item.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>

/* 🔥 修复4：全局样式（放到你的小程序app.wxss/全局样式文件） */
<style>
/* 彻底清除Element UI按钮默认样式 */
.el-button {
  background: none !important;
  border: none !important;
  color: #666 !important;
}
.el-button--primary {
  background: none !important;
  border: none !important;
}
/* 清除所有按钮默认点击样式 */
button::after {
  border: none !important;
}
/* 输入框焦点样式 */
.el-input__inner:focus {
  border-color: #ea5e71 !important;
}
</style>